export default "__VITE_ASSET__2de03a4a__"